module.exports = __webpack_public_path__ + "img/flag_13.2ae6652c.png";